import { DropDownBoxLayoutStyle, YearDropDown } from '@apply/components';
import { useWizardDemoStore } from '../../../../../state/wizardDemoStore';

export const PurchasedYearField = () => {
    const value = useWizardDemoStore((state) => state.property.purchasedYear);
    const updateProperty = useWizardDemoStore((state) => state.updateProperty);

    return (
        <YearDropDown
            id='propertyPurchasedYear'
            value={value}
            // YearDropDown's onChange is typed as string, but it reports the selected year (a number) or null
            onChange={(year) =>
                updateProperty({
                    purchasedYear: year === null || year === undefined || year === '' ? undefined : Number(year),
                })
            }
            label='Purchased Year'
            required={true}
            width={'100%'}
            yearStart={1900}
            placeholder='Select'
            layoutStyle={DropDownBoxLayoutStyle.Horizontal}
            height='36px'
        />
    );
};
